import {FC, useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form'
import ReactQuill from 'react-quill'
import {InputDate, InputNumber, InputText} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {formatDateType2} from '../../../../../../util/dates'
import {ClientModel, CompanyModel} from '../../../../../central/model'
import toolbar from '../../../../../central/pages/Views/EmailTemplateWrapper/toolbar/toolbar'
import {getClient, getCompany} from '../../../../../central/services'
import {SiteModel} from '../../../modules/models'
import {getSitesService} from '../../../modules/services'
import {getTermsByIdService} from '../../services/getTermsById.service'
const FormTerms: FC = () => {
  const {currentTabItem} = useHoteleria()
  const [reception] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [autoService] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [busPark] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [app] = useState([
    {value: true, label: 'SI'},
    {value: false, label: 'NO'},
  ])
  const [company, setCompany] = useState<CompanyModel[] | any>([])
  const [client, setClient] = useState<ClientModel[] | any>([])
  const [sites, setSites] = useState<SiteModel[] | any>([])
  const [text, setText] = useState<'' | any>()
  const handleChange = (html = '') => {
    if (html !== '<p><br></p>') {
      setText(html)
      setValue('TyC', html)
    } else {
      setText('')
      setValue('TyC', '')
    }
  }
  const module = {
    toolbar: toolbar,
  }
  const {
    // reset,
    register,
    formState: {errors},
    control,
    setError,
    setValue,
  } = useFormContext()

  const getCompanyList = async () => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 2000))
      let obj: CompanyModel = {
        isCombo: true,
      }
      const response = await getCompany(obj, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombreEmpresa}))
      if (mappedSites.length === 1) {
        setValue('CompaniaId', mappedSites[0].value)
        setError('CompaniaId', {})
        await getClientList(mappedSites[0].value as string)
      }
      setCompany(mappedSites)
    } catch (error) {
      setCompany([])
    }
  }

  const getClientList = async (companyId: string) => {
    try {
      let obj: ClientModel = {
        isCombo: true,
        companiaId: companyId,
      }
      const response = await getClient(obj, 1)
      const data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      if (mappedSites.length === 1) {
        setValue('ClienteId', mappedSites[0].value)
        setError('ClienteId', {})
        await getSites(mappedSites[0].value as string)
      }
      setClient(mappedSites)
    } catch (error) {
      setClient([])
    }
  }

  const getSites = async (clientId: string) => {
    try {
      let obj: SiteModel = {
        clienteId: clientId,
        isCombo: true,
      }
      const response = await getSitesService(obj, 1)
      const data = response.data.data
      const mappedSites = data?.map((site) => ({value: site.id, label: site.nombre}))
      if (mappedSites.length === 1) {
        setValue('SiteId', mappedSites[0].value)
        setError('SiteId', {})
      }
      setSites(mappedSites)
    } catch (error) {
      setSites([])
    }
  }

  const getBedById = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getTermsByIdService(idToEdit as any)
        const {
          CompaniaId,
          ClienteId,
          SiteId,
          ModRecepcion,
          ModParqueoDeBuses,
          ModAutoservicioTotem,
          ModCheckInAppHuesped,
          Campoadicionaltxt1,
          Campoadicionaltxt2,
          Campoadicionaltxt3,
          Campoadicionaltxt4,
          Campoadicionaltxt5,
          Campoadicionalnum1,
          Campoadicionalnum2,
          Campoadicionalnum3,
          CampoadicionalFec1,
          CampoadicionalFec2,
          TyC,
        } = data
        setValue('Id', idToEdit)
        setValue('CompaniaId', CompaniaId)
        setValue('ClienteId', ClienteId)
        setValue('SiteId', SiteId)
        setValue('ModRecepcion', ModRecepcion)
        setValue('ModParqueoDeBuses', ModParqueoDeBuses)
        setValue('ModAutoservicioTotem', ModAutoservicioTotem)
        setValue('ModCheckInAppHuesped', ModCheckInAppHuesped)
        setValue('Campoadicionaltxt1', Campoadicionaltxt1)
        setValue('Campoadicionaltxt2', Campoadicionaltxt2)
        setValue('Campoadicionaltxt3', Campoadicionaltxt3)
        setValue('Campoadicionaltxt4', Campoadicionaltxt4)
        setValue('Campoadicionaltxt5', Campoadicionaltxt5)
        if (TyC) {
          setText(TyC)
          setValue('TyC', TyC)
        }
        let num1 = Campoadicionalnum1 ? (Campoadicionalnum1 === 0 ? '' : Campoadicionalnum1) : ''
        let num2 = Campoadicionalnum2 ? (Campoadicionalnum2 === 0 ? '' : Campoadicionalnum2) : ''
        let num3 = Campoadicionalnum3 ? (Campoadicionalnum3 === 0 ? '' : Campoadicionalnum3) : ''
        setValue('Campoadicionalnum1', num1)
        setValue('Campoadicionalnum2', num2)
        setValue('Campoadicionalnum3', num3)
        setValue('CampoadicionalFec1', formatDateType2(CampoadicionalFec1))
        setValue('CampoadicionalFec2', formatDateType2(CampoadicionalFec2))
        getClientList(CompaniaId as any)
        getSites(ClienteId as any)
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getBedById()
    }
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    getCompanyList()
  }, [])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    setSites([])
    setError('CompaniaId', {})

    getClientList(value)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setError('ClienteId', {})
    getSites(value)
  }

  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_form card p-4'>
      <div className='d-flex row'>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Compañia:</label>
          <Select
            control={control}
            name='CompaniaId'
            data={company}
            errors={errors}
            onChangeValue={handleCompanyChange}
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Cliente:</label>
          <Select
            control={control}
            name='ClienteId'
            data={client}
            errors={errors}
            onChangeValue={handleClientChange}
            disabled={isDisabled}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Site:</label>
          <Select
            control={control}
            name='SiteId'
            data={sites}
            errors={errors}
            disabled={isDisabled}
          />
        </div>
      </div>
      <div className='d-flex row'>
        <h3>Modalidades</h3>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Recepción:</label>
          <Select control={control} name='ModRecepcion' data={reception} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Autoservicio(totem):</label>
          <Select
            control={control}
            name='ModAutoservicioTotem'
            data={autoService}
            errors={errors}
          />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>Parqueo de buses:</label>
          <Select control={control} name='ModParqueoDeBuses' data={busPark} errors={errors} />
        </div>
        <div className='mb-2 col-sm-12 col-lg-3'>
          <label className='required'>App Huesped:</label>
          <Select control={control} name='ModCheckInAppHuesped' data={app} errors={errors} />
        </div>
        <div className='col-sm-12 col-lg-12'>
          <label className='required'>Términos y condiciones</label>
          <ReactQuill theme='snow' value={text} onChange={handleChange} modules={module} />
          <InputText name='mensaje' register={register} errors={errors} type='hidden' />
        </div>
      </div>
      <hr className='divider' />
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <label>Texto adicional 1:</label>
          <InputText
            name='Campoadicionaltxt1'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Texto adicional 2:</label>
          <InputText
            name='Campoadicionaltxt2'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Texto adicional 3:</label>
          <InputText
            name='Campoadicionaltxt3'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Texto adicional 4:</label>
          <InputText
            name='Campoadicionaltxt4'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Texto adicional 5:</label>
          <InputText
            name='Campoadicionaltxt5'
            textPlaceholder='Escribe el texto adicional'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Número adicional 1:</label>
          <InputNumber
            name='Campoadicionalnum1'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Número adicional 2:</label>
          <InputNumber
            name='Campoadicionalnum2'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Número adicional 3:</label>
          <InputNumber
            name='Campoadicionalnum3'
            textPlaceholder='Escribe el número'
            register={register}
            errors={errors}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Fecha adicional 1:</label>
          <InputDate name='CampoadicionalFec1' register={register} errors={errors} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Fecha adicional 2:</label>
          <InputDate name='CampoadicionalFec2' register={register} errors={errors} />
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
    </div>
  )
}

export {FormTerms}
